import { render } from "./ProductName.vue?vue&type=template&id=783bb97c&ts=true"
import script from "./ProductName.vue?vue&type=script&lang=ts"
export * from "./ProductName.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__